import CustomAvatar from '@/components/CustomAvatar';
import { AvatarGroup, styled } from '@mui/material';
import { AvatarsProps } from './Avatars.types';
import { AvatarsWrapper, MoreUsersText } from './Avatars.styles';
import { avatarBackgroundColors } from './constants/background-colors';

const StyledAvatarGroup = styled(AvatarGroup)`
  ${({ theme }) => theme.breakpoints.between('lg', 'xl')} {
    & .MuiAvatar-root {
      margin-left: ${({ theme }) => theme.spacing(-3)};
    }
  }
`;

function Avatars({
  size = { desktop: 11, mobile: 8 },
  users = [],
  fontSize = { desktop: 4, mobile: 4 },
  className,
  moreUsersText = '',
}: AvatarsProps): JSX.Element {
  return (
    <AvatarsWrapper className={className}>
      <StyledAvatarGroup max={10}>
        {users &&
          users.map((currentUser, key) => (
            <CustomAvatar
              size={size}
              fontSize={fontSize}
              name={currentUser?.name}
              image={currentUser?.image?.url}
              onClick={currentUser?.onClick}
              backgroundColor={avatarBackgroundColors[key]}
              key={`${currentUser?.id}-${Math.random() * 1000}`}
            />
          ))}
      </StyledAvatarGroup>

      {moreUsersText && <MoreUsersText>{moreUsersText}</MoreUsersText>}
    </AvatarsWrapper>
  );
}

export default Avatars;
